import { render, staticRenderFns } from "./carDamageDetail.vue?vue&type=template&id=5b1fbc06&scoped=true"
import script from "./carDamageDetail.vue?vue&type=script&lang=js"
export * from "./carDamageDetail.vue?vue&type=script&lang=js"
import style0 from "./carDamageDetail.vue?vue&type=style&index=0&id=5b1fbc06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1fbc06",
  null
  
)

export default component.exports